module.exports = "/_next/static/images/8654eaa1d9d576bc1cefb291ed831c59-roxinho-basicos-flutuantes-md@2x.png.webp";